import { apiClient } from './apiClient';

export interface ProductDto {
  id: string;
  name: string;
  created: string;
  updated?: string;
}

export interface SupplierDto {
  id: string;
  name: string;
  created: string;
  updated?: string;
}

export interface SupplierBranchDto {
  id: string;
  name: string;
  supplierId: string;
  supplierName: string;
  created: string;
  updated?: string;
}

export interface ProductPriceDto {
  id: string;
  productId: string;
  productName: string;
  price: number;
  date: string;
  supplierId: string;
  supplierName: string;
  branches: string[];
}

export interface CreateProductRequest {
  name: string;
}

export interface CreateSupplierRequest {
  name: string;
}

export interface CreateSupplierBranchRequest {
  name: string;
  supplierId: string;
}

export interface CreateProductPriceRequest {
  productId: string;
  price: number;
  date: string;
  supplierId: string;
  branches: string[];
}

export interface ProductSuggestionRequest {
  ingredientName: string;
  ignoredProductIds: string[];
}

export async function getAllProducts(): Promise<ProductDto[]> {
  return apiClient.get<ProductDto[]>('/api/Products');
}

export async function getProductById(id: string): Promise<ProductDto> {
  return apiClient.get<ProductDto>(`/api/Products/${id}`);
}

export async function createProduct(request: CreateProductRequest): Promise<ProductDto> {
  return apiClient.post<CreateProductRequest, ProductDto>('/api/Products', request);
}

export async function getProductSuggestions(request: ProductSuggestionRequest): Promise<ProductDto[]> {
  return apiClient.post<ProductSuggestionRequest, ProductDto[]>('/api/Products/suggestions', request);
}

export async function getAllSuppliers(): Promise<SupplierDto[]> {
  return apiClient.get<SupplierDto[]>('/api/Products/suppliers');
}

export async function createSupplier(request: CreateSupplierRequest): Promise<SupplierDto> {
  return apiClient.post<CreateSupplierRequest, SupplierDto>('/api/Products/suppliers', request);
}

export async function getAllSupplierBranches(): Promise<SupplierBranchDto[]> {
  return apiClient.get<SupplierBranchDto[]>('/api/Products/supplier-branches');
}

export async function createSupplierBranch(request: CreateSupplierBranchRequest): Promise<SupplierBranchDto> {
  return apiClient.post<CreateSupplierBranchRequest, SupplierBranchDto>('/api/Products/supplier-branches', request);
}

export async function createProductPrice(request: CreateProductPriceRequest): Promise<ProductPriceDto> {
  return apiClient.post<CreateProductPriceRequest, ProductPriceDto>('/api/Products/prices', request);
}

